import React from "react";
import Timer from "../components/Header/Timer/Timer";

const About = () => {
  const currentYear = new Date().getFullYear();
  return (
    <>
      <div className="p-5 mx-5 bg-gradient-to-b from-[#e2ce9d] to-[#f9b866]">
        <div className="max-w-4xl mx-auto">
          <div className="mx-auto mt-5 text-center text-2xl font-[Bold] text-[#503854]">
            CO TO JEST PODSUMOWANIE?
          </div>
          <div className="p-1 w-full mt-5 drop-shadow-xl bg-[#503854] rounded" />
          <div className="p-2 mt-5 font-[Light]">
            PODSUMOWANIE ROKU NA POZNAŃSKIEJ SCENIE HIPHOPOWEJ TO COROCZNA AKCJA
            PORTALU POZNANSKIRAP.COM ODBYWAJĄCA SIĘ NIEPRZERWANIE OD ROKU 2009
            GDZIE JAKO JEDYNI ODDAJEMY PEŁNĄ KONTROLĘ CZYTELNIKOM I WIDZOM W
            WYBORZE NAJLEPSZYCH PRZEDSTAWICIELI W SIEDMIU KATEGORIACH NASZEGO
            GŁOSOWANIA.
          </div>
          <div className="mx-auto mt-5 text-center text-3xl font-[Bold] text-[#503854]">
            PODSUMOWANIE POZNAŃSKIEJ SCENY RAPOWEJ {currentYear - 1}
          </div>
          <div className="p-1 w-full mt-5 drop-shadow-xl bg-[#503854] rounded" />{" "}
          <div className="p-2 mt-5 font-[Light]">
            KATEGORIE, W KTÓRYCH MOŻECIE WYBIERAĆ SWOICH FAWORYTÓW TO: ARTYŚCI,
            PRODUCENCI, DJ'E ORAZ ALBUMY, TELEDYSKI, IMPREZY I WYDARZENIA Z
            MINIONEGO ROKU.
          </div>
          <div className="p-2 mb-5 font-[Light]">
            CAŁA AKCJA PODZIELONA JEST NA TRZY ETAPY - ZGŁASZANIE PROPOZYCJI,
            GŁOSOWANIE NA FAWORYTÓW W POSZCZEGÓLNYCH KATEGORIACH ORAZ OGŁOSZENIE
            WYNIKÓW.
          </div>
          <Timer />
          <div className="p-2 font-[Light]">
            NA GÓRZE STRONY ZNAJDUJE SIĘ LICZNIK POKAZUJĄCY ILE CZASU ZOSTAŁO DO
            ZAKOŃCZENIA PODSUMOWANIA, A CAŁA AKCJA TRWA OD 3 MARCA DO 11 MAJA {currentYear} ROKU.
          </div>
          <div className="p-2 font-[Light]">
            PAMIĘTAJCIE - TO WY DECYDUJECIE I MACIE BEZPOŚREDNI WPŁYW KTO
            ZOSTANIE ZGŁOSZONY W DANEJ KATEGORII ORAZ KOGO WYBIERZECIE JAKO
            ZWYCIĘZCĘ.
          </div>
          <div className="mx-auto w-28 flex justify-center">
            <img
              className="py-5"
              src={`${process.env.REACT_APP_API_DOMAIN}/images/voucher100zl.png`}
            />
            <img
              className="py-5"
              src={`${process.env.REACT_APP_API_DOMAIN}/images/voucher200zl.png`}
            />
            <img
              className="py-5"
              src={`${process.env.REACT_APP_API_DOMAIN}/images/voucher300zl.png`}
            />
          </div>
          <div className="p-2 font-[Light]">
            WŚRÓD OSÓB BIORĄCYCH UDZIAŁ W PODSUMOWANIU ROKU ROZLOSUJEMY NAGRODY
            OD SPONSORÓW NASZEJ AKCJI: SKLEPU WUJO POZNAŃ ORAZ RAPGRINDER.PL.
            JEŻELI CHCECIE SPRAWDZIĆ CO UFUNDOWALI NASI PARTNERZY WCHODŹCIE W
            ZAKŁADKĘ NAGRODY.
          </div>
          <img
            className="py-5 mx-auto"
            src={`${process.env.REACT_APP_API_DOMAIN}/images/landingpage_wyniki.png`}
          />
          <div className="p-2 font-[Light]">
            JEŻELI JESTEŚCIE ZAINTERESOWANI WYNIKAMI NASZEJ AKCJI Z POPRZEDNICH
            JEJ EDYCJI TO ZACHĘCAMY DO SPRAWDZANIA DZIAŁU WYNIKI.
          </div>
        </div>
        <div className="p-1 mb-5 mx-auto w-full max-w-4xl mt-5 drop-shadow-xl bg-[#503854] rounded" />
      </div>
    </>
  );
};

export default About;
